import ContentCard from './contentCard.component';

export default ContentCard;